import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M15.25 7.25V13.5C15.25 15.2949 13.7949 16.75 12 16.75C10.2051 16.75 8.75 15.2949 8.75 13.5V7.25" strokeLinecap="square" vectorEffect="non-scaling-stroke" />
		<Path d="M8 19.5H16" vectorEffect="non-scaling-stroke" />
	</SVG>
);
